// Froala positions popups relative to the toolbar button and clamps them to the viewport,
// not to the editor. Inside a narrow container (e.g. a dialog) the popup can extend past the
// editor's right edge and force horizontal scrolling. Align the popup's right edge with the
// triggering button (falling back to Froala's position when there is no button), always
// keeping it inside the editor box.
// biome-ignore lint/suspicious/noExplicitAny: Froala editor instance typed as any
export const alignPopupWithinEditor = (editor: any, popupId: string, buttonCmd?: string) => {
  const popupEl = editor.popups?.get(popupId)?.get(0);
  const boxEl = editor.$box?.get(0);
  if (!popupEl || !boxEl) {
    return;
  }
  const buttonEl = buttonCmd ? editor.$tb?.find(`[data-cmd="${buttonCmd}"]`)?.get(0) : null;
  const desiredLeft = buttonEl
    ? buttonEl.getBoundingClientRect().right -
      boxEl.getBoundingClientRect().left -
      popupEl.offsetWidth
    : Number.parseFloat(popupEl.style.left) || 0;
  const maxLeft = Math.max(0, boxEl.offsetWidth - popupEl.offsetWidth);
  popupEl.style.left = `${Math.min(Math.max(desiredLeft, 0), maxLeft)}px`;
};
